export const SUBMIT_BUTTON_TEST_ID = {
  submitButton: 'submit-button',
};
